import React, { Component } from 'react';
import { Button, Icon } from 'antd';
import { language } from '../../../language';

import { utils } from '../../../services';
//导航提示
export class NavTips extends Component<{
    items: Array<any>;
    onChange: (value: any) => void;
}> {
    addItem = () => {
        const { items, onChange } = this.props;
        onChange([...items, { uuid: utils.uuid() }]);
    };

    render() {
        return (
            <div className="entry-item item-create">
                <p>
                    <Button type={'link'} onClick={this.addItem}>
                        <Icon type="plus" /> {language.getText('components.Nav.addNav')}
                    </Button>
                </p>
                <p>{language.getText('components.Nav.imageSize')}</p>
            </div>
        );
    }
}
